import { useMemo } from 'react';
import { ApolloError, useQuery } from '@apollo/client';
import gql from 'graphql-tag';
import { Query } from '@gql/generated';

export const FLAGS_QUERY = gql`
  query flagsQuery($names: [String!]!) {
    flipperFlags(names: $names) {
      name
      value
    }
  }
`;

export const names = [
  'payments_adyen',
  'yearly_campaign',
  'quarterly_campaign',
  'disable_trustly',
  'disable_hls',
  'google_oauth_feature',
  'sommar99_campaign',
  'search_disabled',
  'enable_trialclaim_modal',
  'mindfulnesskalendern',
  'video_stats',
  'disable_dashboard_stats',
  'wellness',
  'yearly_campaign_banners',
] as const;

type AvailableFlags = { [k in typeof names[number]]: boolean };

function buildFlags(flags) {
  return (
    flags?.reduce((acc, flag) => {
      acc[flag.name] = flag.value;
      return acc;
    }, {}) || {}
  );
}

const useFlags = (): [
  AvailableFlags,
  { loading: boolean; error: ApolloError }
] => {
  const { data, loading, error } = useQuery<{
    flipperFlags: Query['flipperFlags'];
  }>(FLAGS_QUERY, {
    variables: {
      names,
    },
  });

  const flags: AvailableFlags = useMemo(() => {
    const flags = buildFlags(data?.flipperFlags);
    return flags;
  }, [data?.flipperFlags]);

  return [flags, { loading, error }];
};

export default useFlags;
